import { MgSupplierItemSearchField } from '@retail/products/components';
import { SupplierBase } from '@retail/suppliers/types';
import { ProductGroup } from '@retail/products/types';
import { SideFilters } from '@retail/components';
import { ExcludeVatSwitch, SelectProductGroup } from '@retail/my-assortment/components';
import { useAppTFunction } from '@retail/app/i18n';
import { useCallback } from 'react';
import { SelectSupplier } from '@retail/suppliers/components';

interface Props {
  searchTerm: string;
  disableFields: boolean;
  suppliers: SupplierBase[];
  productGroups: ProductGroup[];
  selectedSupplier: number | null;
  selectedProductGroup: string | null;
  showFilters: boolean;
  includeVat: boolean;
  toggleIncludeVat: () => void;
  selectSupplier: (supplierId: number | null) => void;
  selectProductGroup: (productGroupNr: string | null) => void;
  setSearchTerm: (term: string) => void;
  setPage: (page: number) => void;
}

export function CampaignDetailsFilters({
  searchTerm,
  disableFields,
  suppliers,
  productGroups,
  selectedSupplier,
  selectedProductGroup,
  showFilters,
  includeVat,
  toggleIncludeVat,
  selectSupplier,
  selectProductGroup,
  setSearchTerm,
  setPage,
}: Props) {
  const t = useAppTFunction();

  const onSubmitSearch = useCallback(
    (searchQuery: string) => {
      setPage(0);
      setSearchTerm(searchQuery);
    },
    [setPage, setSearchTerm]
  );

  return (
    <SideFilters heading={t('calculus.filter')} showFilters={showFilters} sx={{ height: '100%' }}>
      <ExcludeVatSwitch toggleVat={includeVat} handleToggleVat={toggleIncludeVat} />
      <SelectSupplier
        suppliers={suppliers}
        selectedSupplier={selectedSupplier}
        getSupplierId={(supplier: SupplierBase) => supplier.supplierNumber}
        getSupplierName={(supplier: SupplierBase) => supplier.name}
        selectSupplier={selectSupplier}
      />
      <SelectProductGroup
        productGroups={productGroups}
        selectedProductGroup={selectedProductGroup}
        selectProductGroup={selectProductGroup}
      />
      <MgSupplierItemSearchField
        size="small"
        width="100%"
        searchTerm={searchTerm}
        isDisabled={disableFields}
        onSubmitSearch={onSubmitSearch}
      />
    </SideFilters>
  );
}
